import { useI18n } from '@i18n/useI18n';
import { NumberRollContainer } from './NumberRoll.styled';
import { forwardRef, useEffect, useRef, useState } from 'react';
import SlotCounter from 'react-slot-counter';


interface IProps {
  number: number
  newNumber: number
  isAdmin: boolean
  isDemo: boolean
  stop: () => void
  countDown?: boolean
}

export const NumberRoll = (props: IProps, ref) => {
  const [n, setN] = useState(props.countDown ? props.newNumber : props.number)
  const animation = useRef(null)

  useEffect(() => {
    if (props.isAdmin) {
      setN(props.newNumber)
    }
    else {
      if ((props.newNumber > props.number && !props.countDown) || (props.countDown && props.newNumber > 0))
        animation.current = setInterval(() => {
          setN((n) => {
            if (props.countDown) {
              if (n > 0) {
                if (n - 3 < 0) return 0
                else return n - 3
              }
              else {
                props.stop()
                clearInterval(animation.current)
                return 0
              }
            }
            else {
              if (n < props.newNumber) {
                if (n + 3 > props.newNumber) return props.newNumber
                else return n + 3
              }
              else {
                props.stop()
                clearInterval(animation.current)
                return n
              }
            }
          }
          )
        }, 50)
    }
  }, []);

  useEffect(() => {
    if (props.isDemo) {
      if ((props.newNumber > props.number && !props.countDown) || (props.countDown && props.newNumber > 0)) {
        if (props.countDown && props.newNumber > 0) setN(props.newNumber)
        animation.current = setInterval(() => {
          setN((n) => {
            if (props.countDown) {
              if (n > 0) {
                if (n - 3 < 0) return 0
                else return n - 3
              }
              else {
                props.stop()
                clearInterval(animation.current)
                return 0
              }
            }
            else {
              if (n < props.newNumber) {
                if (n + 3 > props.newNumber) return props.newNumber
                else return n + 3
              }
              else {
                props.stop()
                clearInterval(animation.current)
                return n
              }
            }
          }
          )
        }, 50)
      }

    }
  }, [props.isDemo, props.number, props.newNumber])


  return (
    <NumberRollContainer show={(props.countDown && (props.newNumber > 0 && n > 0)) || !props.countDown}>
      <SlotCounter startValueOnce startValue={props.number} value={n} duration={0.05} sequentialAnimationMode useMonospaceWidth={true} />
    </NumberRollContainer>
  );
};

export default NumberRoll;


